<template>
  <el-dialog
    :visible="true"
    width="500px"
    @close="$router.replace('/users')"
  >
    <div
      slot="title"
    >
      {{ title }}
      <el-tag type="info" v-if="user.id === loggedInUser.id" size="small" style="margin-left: 5px;">Saját felhasználó</el-tag>
    </div>
    <el-tabs v-model="activeName" v-loading="loading">
      <el-tab-pane label="Alapadatok" name="1">
        <el-table
          :data="userData"
          :show-header="false"
          border
        >
          <el-table-column
            prop="label"
          >
            <template slot-scope="scope">
              <strong>{{ scope.row.label }}</strong>
            </template>
          </el-table-column>
          <el-table-column
            prop="value"
          />
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="Napló" name="2">
        <activity-timeline
          v-if="user && user.activities"
          :activities="user.activities"
          :propsMap="propsMap"
        />
      </el-tab-pane>
    </el-tabs>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/users/update/' + user.id)" type="primary" icon="el-icon-edit">
        Módosítás
      </el-button>
      <el-tooltip
        class="item"
        effect="dark"
        v-if="loggedInUser.id === user.id"
        content="Saját felhasználó törlése nem lehetséges"
        placement="top"
      >
        <el-popover
          placement="bottom"
          width="171"
          v-model="deleteConfirmVisible"
        >
          <p>Biztosan törölni szeretnéd?</p>
          <div style="text-align: right; margin: 0">
            <el-button
              size="mini"
              type="text"
              @click="deleteConfirmVisible = false"
            >
              Mégse
            </el-button>
            <el-button
              type="danger"
              size="mini"
              @click="deleteUser()"
            >
              Törlés
            </el-button>
          </div>
          <el-button
            slot="reference"
            :loading="deleteButtonLoader"
            icon="el-icon-delete"
            type="danger"
            :disabled="loggedInUser.id === user.id"
            style="margin-left: 5px;"
          >
            Törlés
          </el-button>
        </el-popover>
      </el-tooltip>
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
        v-if="loggedInUser.id !== user.id"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteUser()"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          icon="el-icon-delete"
          type="danger"
          style="margin-left: 5px;"
        >
          Törlés
        </el-button>
      </el-popover>
    </div>
  </el-dialog>
</template>

<script>
import ActivityTimeline from '../ActivityTimeline';

export default {
  components: { ActivityTimeline },
  props: ['userId'],
  data() {
    return {
      activeName: '1',
      deleteButtonLoader: false,
      deleteConfirmVisible: false,
      title: 'Betöltés folyamatban...',
      loading: false,
      buttonLoading: false,
      user: {},
      userData: [],
      propsMap: {
        'last_name': 'Vezetéknév',
        'first_name': 'Keresztnév',
        'mobile': 'Mobil',
        'email': 'E-mail',
        'username': 'Felhasználónév',
      },
    };
  },
  watch: {
    userId(newVal) {
      this.activeName = '1';
      this.fetchData();
    },
  },
  computed: {
    loggedInUser() {
      return this.$store.getters['auth/user'];
    },
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.user = await axios.get(`api/users/${this.userId}`);
      this.title = `${this.user.last_name} ${this.user.first_name}`;
      this.userData = [
        {
          label: 'Teljes név',
          value: this.user.last_name + ' ' + this.user.first_name
        },
        {
          label: 'Felhasználónév',
          value: this.user.username
        },
        {
          label: 'E-mail',
          value: this.user.email
        },
        {
          label: 'Mobil',
          value: this.$options.filters.phone(this.user.mobile)
        },
        {
          label: 'Létrehozva',
          value: this.$options.filters.dateTime(this.user.created_at)
        },
        {
          label: 'Módosítva',
          value: this.$options.filters.dateTime(this.user.updated_at)
        },
      ];
      this.loading = false;
    },
    async deleteUser() {
      this.deleteButtonLoader = true;
      this.deleteConfirmVisible = false;
      try {
        await this.$store.dispatch('user/delete', this.user.id);
        this.$store.dispatch('user/fetchAll');
        this.$messageWrapper.success('Felhasználó sikeresen törölve');
        this.$router.replace('/users');
      } catch (e) {
        this.$messageWrapper.error('Felhasználó törlése közben hiba történt');
      }
      this.deleteButtonLoader = false;
    }
  },
};
</script>
